
<!-- ____________ Start Header _____________ -->
<header>
  <nav class="navbar navbar-expand-lg fixed-top shadow-sm">
    <div class="container">

      <!-- toggle sidebar in mobile -->
      <button
        (click)=" toggleSidebar() "
        [ngClass]="{
          'show-sidebar': !isSidebarOpen
        }"
        class="navbar-toggler mr-2 collapsed"
        type="button"
       >

        <span class="con d-block">
          <span class="bar top"></span>
          <span class="bar middle"></span>
          <span class="bar bottom"></span>
        </span>
    
      </button>

      <!-- Logo -->
      <a class="navbar-brand"
        (click)=" isSidebarOpen = false "
        routerLink="">
        <img class="d-none d-md-block desktop" src="assets/images/header/logo.png" alt="Logo">
        <img class="d-block d-md-none mobile" src="assets/images/header/mobile-logo.png" alt="Logo">
      </a>

      <!-- navbar -->
      <ul class="navbar-nav ml-auto mb-lg-0">

        <!-- home -->
        <li class="nav-item  d-none d-lg-flex">
          <a class="nav-link"
           (click)=" isSidebarOpen = false "
           routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
           {{ 'Home' | translate }} 
          </a>
        </li>

        <!-- Our Branches -->
        <li class="nav-item d-none d-lg-flex">
          <a class="nav-link"
            (click)=" isSidebarOpen = false "
            [routerLink]="['/our-branches']"
            routerLinkActive="active"
          >
          {{ 'Our_Branches' | translate }} 
        </a>
        </li>

        <!-- cart -->
        <li class="nav-item icon cart">
          <a class="nav-link"
            (click)=" isSidebarOpen = false;"
            [routerLink]="['/cart']"
            routerLinkActive="active"
            #cartRef="routerLinkActive">
            <img src="assets/images/header/cart.png" alt="Cart">
            <span class="dot" [ngClass]="{
              'hide' : !_OrdersService.orders.length || cartRef.isActive
            }"></span>
          </a>
        </li>

        <!--  if the user is anonymous -->
        <li *ngIf="!isUser" class="nav-item icon user">
          <a class="nav-link"
            (click)=" isSidebarOpen = false"
            routerLink="/auth/login" routerLinkActive="active">
            <img src="assets/images/header/user.png" alt="User">
          </a>
        </li>
        <!--  -->
        <li *ngIf="isUser" class="nav-item icon user">
          <a class="nav-link"
            (click)=" isSidebarOpen = false "
            routerLink="/profile" routerLinkActive="active">
            <span class="info user-name">{{oneUser?.name.split(' ')[0]}}</span> 
            <img src="assets/images/header/user.png" alt="User">
          </a>
          <!-- {{oneUser | async | json}} -->
        </li>

        <!-- toggle language -->
        <li class="nav-item icon lang">
          <button  class="nav-link btn"
            (click)=" isSidebarOpen = false; changeLanguage()">
            <span class="info d-none d-md-inline ar">{{languageSite}}</span> 
            <span class="info d-inline d-md-none ar">{{languageMobi}}</span> 
            <img src="assets/images/header/lang.png" alt="Lang">
          </button>
        </li>

      </ul>


    </div>
  </nav>

  <!-- mobile sidebar-->
  <aside class="shadow-sm"
    [ngClass]="{
      'opened': isSidebarOpen
    }"
  >
    <div class="px-3 h-100">

      <!-- Logo -->
      <a class="navbar-brand mb-4 mr-0 text-center d-block"
        (click)=" toggleSidebar() "
        routerLink=""
      >
        <img src="assets/images/header/logo-txt.png" alt="Logo">
      </a>

      
      <div class="sidebar-content h-100">

        <!-- mobile  navbar -->
        <ul class="navbar-nav mb-lg-0 w-100">
          <!-- home -->
          <li class="nav-item mb-2">
            <a class="nav-link"

              (click)=" toggleSidebar() "
              routerLink=""
              routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}"

            >
            {{ 'Home' | translate }} 
          </a>
          </li>

          <!-- Our Branches -->
          <li class="nav-item mb-2">
            <a class="nav-link"
              (click)=" toggleSidebar()"
              [routerLink]="['/our-branches']"
              routerLinkActive="active"
            >
            {{ 'Our_Branches' | translate }} 
          </a>

          </li>
        </ul>

        <!-- social media icons -->
        <div class="follow-us">
          <div class="col-title">
            <h6>
              {{ 'Follow_us_on' | translate }} 
            </h6>
          </div>

          <div class="social">
            <a target="_blanck" class="mr-2" href="https://www.facebook.com/QaysarPizza/"><i class="fa fa-facebook" aria-hidden="true"></i></a>
            <a target="_blanck" href="https://www.instagram.com/qaysarpizza/"><i class="fa fa-instagram"></i></a>
          </div>
        </div>

      </div>


    </div>
  </aside>

  <!-- overlay -->
  <div
    class="overlay"
    (click)=" toggleSidebar() "
    [ngClass]="{
      'd-block' : isSidebarOpen
    }"
   > 
  </div>

</header>
<!-- ____________ End Header _____________ -->





